import * as React from 'react';

import * as CommonUx from '@abb/common-ux';
import { ICountry } from '@module/shared';

interface IContactInformationProps {
  name: string;
  email: string;
  confirmEmail: string;
  company: string;
  phone: string;
  location: string;
  postal: string;
  country: string;
  countries: ICountry[];
  validationStateName: CommonUx.VALIDATION_STATE;
  validationStateEmail: CommonUx.VALIDATION_STATE;
  validationStateConfirmEmail: CommonUx.VALIDATION_STATE;
  validationStateCompany: CommonUx.VALIDATION_STATE;
  validationStateLocation: CommonUx.VALIDATION_STATE;
  validationStateCountry: CommonUx.VALIDATION_STATE;  
  validationStatePhoneNumber: CommonUx.VALIDATION_STATE;
  validationStatePostalCode: CommonUx.VALIDATION_STATE;
  errorMessageName: string;
  errorMessageEmail: string;
  errorMessageConfirmEmail: string;
  errorMessageCompany: string;
  errorMessagePhoneNumber: string;
  errorMessageLocation: string;
  errorMessagePostalCode: string;
  onBlurName: () => void;
  onBlurEmail: () => void;
  onBlurConfirmEmail: () => void;
  onBlurCompany: () => void;
  onBlurPhoneNumber: () => void;
  onBlurLocation: () => void;
  onBlurPostalCode: () => void;
  onChangeInput: (event: React.ChangeEvent<any>) => void;
  onChangeCountry: (opt: CommonUx.Option) => void;
}

export const ContactInformation = (props: IContactInformationProps) => {

  const countriesOptions: any[] = [{
    label: '', value: ''
  }];
  props.countries.map((value: ICountry) => {
    countriesOptions.push({ label: value.countryName, value: value.countryName });
  });
  
  return (
    <div>
      <div className='row'>
        <div className='col-sm-12'>
          <b><p>Please provide your contact information so we may send you the full report within 48 hours. Please read our <a href='https://new.abb.com/privacy-notice/' target='_blank'>Privacy Notice</a> before proceeding.</p></b>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-6'>
          <CommonUx.TextInput
            name='contactName'
            labelText='Contact Name'
            inputSize='full'
            isRequired={true}
            value={props.name}
            errorMessage={props.errorMessageName}
            validationState={props.validationStateName}
            onChange={props.onChangeInput}
            onBlur={props.onBlurName}
          />
        </div>
        <div className='col-sm-6'>
          <CommonUx.TextInput
            name='companyName'
            labelText='Company Name'
            inputSize='full'
            isRequired={true}
            value={props.company}
            errorMessage={props.errorMessageCompany}
            validationState={props.validationStateCompany}
            onChange={props.onChangeInput}
            onBlur={props.onBlurCompany}
          />
        </div>
      </div>
      <div className='row'>  
        <div className='col-sm-6'>
          <CommonUx.TextInput
            name='contactEmail'
            labelText='Email Address'
            inputSize='full'
            isRequired={true}
            value={props.email}
            errorMessage={props.errorMessageEmail}
            validationState={props.validationStateEmail}
            onChange={props.onChangeInput}
            onBlur={props.onBlurEmail}
          />
        </div>
        <div className='col-sm-6'>
          <CommonUx.TextInput
            name='confirmContactEmail'
            labelText='Re-Enter Email Address'
            inputSize='full'
            isRequired={true}
            value={props.confirmEmail}
            errorMessage={props.errorMessageConfirmEmail}
            validationState={props.validationStateConfirmEmail}
            onChange={props.onChangeInput}
            onBlur={props.onBlurConfirmEmail}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-6'>
          <CommonUx.TextInput
            name='phoneNumber'
            labelText='Phone Number'
            placeholder='ex: +1-555-321-1234'
            inputSize='full'
            value={props.phone}
            errorMessage={props.errorMessagePhoneNumber}
            validationState={props.validationStatePhoneNumber}
            onChange={props.onChangeInput}
            onBlur={props.onBlurPhoneNumber}
          />
        </div>
        <div className='col-sm-6'>
          <CommonUx.TextInput
            name='location'
            labelText='Location'
            inputSize='full'
            placeholder='ie. City, State/Province'
            isRequired={true}
            value={props.location}
            errorMessage={props.errorMessageLocation}
            validationState={props.validationStateLocation}
            onChange={props.onChangeInput}
            onBlur={props.onBlurLocation}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-6'>
          <CommonUx.TextInput
            name='postalCode'
            labelText='Postal Code'
            inputSize='full'
            value={props.postal}
            errorMessage={props.errorMessagePostalCode}
            validationState={props.validationStatePostalCode}
            onChange={props.onChangeInput}
            onBlur={props.onBlurPostalCode}
          />
        </div>
        <div className='col-sm-6'>
          <CommonUx.ComboBox
            labelText='Country'
            size='default'
            searchable={true}
            required={true}
            options={countriesOptions}
            value={props.country}
            validationState={props.validationStateCountry}
            onChange={props.onChangeCountry}
            matchPos='start'
          />
        </div>
      </div>
    </div>
  );
};
